import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { minGoodAgeForDreamInMinutes } from "source/app/presentation/MainPanel/Dreams/InfoIcon/DreamInfoIcons";

export function DecisionTimeLeftBadge({
    dreamAgeInMinutes,
}: {
    dreamAgeInMinutes: number;
}) {
    const badgeStyleClass = StyleClass(`decisionTimeLeftBadge`, {
        color: "white",
        position: "relative",
        background: "#ab0000",
        padding: "0px 4px",
        fontSize: "11px",
        borderRadius: "7px",
        bottom: `1px`,
    });

    const minutesLeftBeforeAction =
        GetMinutesLeftBeforeActionable(dreamAgeInMinutes);

    const tooltipText = GetTooltipText(
        dreamAgeInMinutes,
        minutesLeftBeforeAction
    );

    return (
        <span>
            <span data-tip={tooltipText}>
                <span className={badgeStyleClass}>
                    {minutesLeftBeforeAction}
                </span>
            </span>
        </span>
    );
}

function GetTooltipText(
    dreamAgeInMinutes: number,
    minutesLeftBeforeAction: number
) {
    return `${dreamAgeInMinutes} minutes since the last update. Give it another ${minutesLeftBeforeAction} minutes before taking action`;
}

function GetMinutesLeftBeforeActionable(dreamAgeInMinutes: number) {
    return minGoodAgeForDreamInMinutes - dreamAgeInMinutes;
}
